import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  background-color: #000;
  border: 1px solid #000;
  color: #fff;
  pointer-events: all;
  a {
    color: #fff !important;
  }
`

const Black = ({children}) => {
  return (
    <Container>
      {children}
    </Container>
  )
}

export default Black
